<template>
  <div class="page-wrapper">
    <search-list :enumList="enumList"
                 @searchData="search"
                 :conditions="conditions"
    ></search-list>
    <div class="page-wrapper" style="padding-top: 0">
      <Button  v-p="{api:'business/createBusiness'}" type="primary" @click.stop="addN++" class="mb16">新建商机</Button>
      <Button type="primary" class="btn mb16" @click="assignBusiness"
              v-p="{api:'business/allocateBusiness'}"
      >分配商机</Button>
      <table-list
        :columns="columns"
        :data="data"
        :current="current"
        :total="total"
        :loading="loading"
        @change-page="changPage"
        @on-selection-change="selectItem"
      ></table-list>
      <add :n="addN" :enumList="enumList" :conditions="conditions" @refresh="search(searchParams)"></add>
<!--      <update :n="updateN" :item="itemData" :metaList="metaList" @done="getList"></update>-->
      <read :n="readN" :data="readObj"></read>
      <handle :n="handleN"
              :statusList = "handleStatusList"
              :data="handleObj"
              :enumList="enumList" :conditions="conditions"
              @refresh="search(searchParams)"

      ></handle>
      <assign-business-modal
        :selectedBusiness="selectedBusiness"
        :projectFid = "assginProjectFid"
        :projectName = "projectName"
        :count = "selectedBusiness.length"
        :cityCode="assignCityCode"
        :n="assignKey"
        @refresh="search(searchParams)">
      </assign-business-modal>
    </div>
  </div>
</template>

<script>
  import SearchList from './components/SearchList'
  import TableList from 'components/TableList/index';
  // import {allMetaWithExt,metaListByPage,deleteMeta} from "../../../api/meta";
  import {formatDateTime,formatDateTimeExceptSecond} from "../../../utils/format"
  import {enterpriselist} from "../../../api/business";
  import Add from './components/Add'
  import Read from './components/Read'
  import Handle from './components/Handle'
  import {getBusinessEnums,getConditions,allowHandleBusiness} from "../../../api/business";
  import AssignBusinessModal from './components/AssignBusinessModal';
  import {deepClone} from "../../../utils/format";

  export default {
    name: "enterbusiness",
      components: {
        SearchList,
        TableList,
        Add,
        Read,
        Handle,
        AssignBusinessModal
      },
    created(){
      // this.allMetaWithExt()
      this.getBusinessEnums()
    },
    data(){
      return {
        assignCityCode:'',
        selectedBusiness:[],
        assginProjectFid:'',
        assignKey:0,
        projectName:'',
        handleObj:null,
        handleStatusList:[],
        readObj:null,
        itemData:null,
        updateN:0,
        addN:0,
        readN:0,
        handleN:0,
        data: [],
        columns: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: ' '
          },
          {
            title: '商机状态',
            key: 'handleStatusName',
            width:120,
            align: 'center',
            render: (h,params) => {
              return h('div',{
                'class': {
                  'error-color': params.row.handleStatus == 0,
                  'warning-color ': params.row.handleStatus == 2,
                  'success-color':params.row.handleStatus == 1,
                  'content-color':params.row.handleStatus == 3,
                  'disable-color':params.row.handleStatus == 4 || params.row.handleStatus == 5 || params.row.handleStatus == 6,
                },
              },params.row['handleStatusName'])
            }
          },

          {
            title: ' '
          },
          {
          title: '商机等级',
          key: 'grade',
          align: 'center',
          width:90
        },
        {
            title: ' '
          },
          {
            title: '创建时间',
            key: 'createTime',
            align: 'center',
            width:180
          },
          {
            title: ' '
          },
          {
            title: '截止处理时间',
            key: 'backlogTimeDate',
            align: 'center',
            width:180,
            render: (h,params) => {
              return h('div',formatDateTimeExceptSecond(new Date(params.row.backlogTimeDate)))
            }
          },

          {
            title: ' '
          },
          {
            title: "企业名称",
            align: 'center',
            key: 'companyName',
            width: 180,
          },
          {
            title: ' '
          },
          {
            title: "企业联系人",
            align: 'center',
            key: 'customerName',
            width: 120,
          },
          {
            title: "联系电话",
            align: 'center',
            key: 'customerPhone',
            width: 160,
          },
          {
            title: ' '
          },
          {
            title: "入住人数",
            align: 'center',
            key: 'checkinNum',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: "预算",
            align: 'center',
            key: 'budgetRangeName',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: "最新跟进内容",
            align: 'center',
            key: 'handleRecord',
            width: 240,
            // className: 'feedback-text-container',
            render: (h, params) => {
              if (params.row['handleRecord'] && params.row['handleRecord'].length > 13) {
                return h('Tooltip', {
                  props: {
                    placement: "bottom"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, params.row['handleRecord']),
                  h('span', {}, params.row['handleRecord'].slice(0, 13) + '...')


                ])

              }
              else {
                return h('span', {}, params.row['handleRecord'])
              }
            }

            // render: (h, params) => {
            //   return h('div',[
            //     h('div',{
            //       class:{
            //         'feedback-text-wrapper':true,
            //       },
            //       style:{
            //         '-webkit-line-clamp': params.row.expandText ? '2' : 'inherit'
            //       }
            //     //  aaa
            //     },params.row.handleRecord),
            //     h('Button',{
            //       props:{
            //         type:'text',
            //         size:'small'
            //       },
            //       style:{
            //         'display': params.row.expandTextButton ? 'block' : 'none',
            //         'float':'right'
            //       },
            //       on:{
            //         'click':() => {
            //           let test=1
            //           this.changeTableRowTextExpandState(params.index)
            //
            //         }
            //       }
            //
            //     },params.row.expandText ? '展开' : '收起')
            //   ])
            // }
          },
          {
            title: ' '
          },
          {
            title: "期望入住时间",
            align: 'center',
            key: 'expectCheckinTime',
            width: 140,
          },
          {
            title: ' '
          },
          {
            title: "期望租住时长",
            align: 'center',
            key: 'rentPeriodStr',
            width: 140,
          },
          {
            title: ' '
          },
          {
            title: "跟进人",
            align: 'center',
            key: 'zoName',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: "来源渠道",
            align: 'center',
            key: 'businessFromChannelName',
            width: 120,
          },
          {
            title: ' '
          },


          {
            title: "项目名称",
            align: 'center',
            key: 'projectName',
            width: 160,
          },
          {
            title: ' '
          },
          {
            title: '商机类型',
            key: 'businessTypeName',
            align: 'center',
            width:180
          },
          {
            title: ' '
          },
          {
            title: "城市",
            align: 'center',
            key: 'cityName',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: "操作",
            align: 'center',
            key: 'action',
            fixed:'right',
            width: 120,
            render: (h,params)=>{
              return h('div',[
                h('a',{
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'business/getDetail'
                      }
                    }
                  ],
                  style: {
                    marginRight: '5px'
                  },
                  on:{
                    click: () => {
                      this.readN++
                      this.readObj=params.row
                      // this.isRead = true
                      // this.readOrHandleKey++;
                      // this.businessFid = params.row.businessFid
                      // this.detailProjectFid = params.row.projectFid

                    }
                  }
                },'跟进记录'),
                h('a',{
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'business/saveBusinessHandle'
                      }
                    }
                  ],
                  style: {
                    marginRight: '5px',
                    display: (params.row.handleStatus==4 || params.row.handleStatus == 5 || params.row.handleStatus ==6) ? 'none' :'inline-block'
                  },
                  on:{
                    click: () => {
                      allowHandleBusiness(params.row.businessFid).then( res => {
                        if(res.data==='true' ) {
                          if( !this.conditions||  !this.conditions.status){
                            return
                          }
                          this.handleStatusList = []
                          let statusList=[]


                          if(this.conditions && this.conditions.status){
                            statusList=deepClone(this.conditions.status)


                            const index = statusList.findIndex(item => {
                              return item.value == 0
                            })
                            if(index > -1) {
                              statusList.splice(index,1)
                            }
                            const index2 = statusList.findIndex(item => {
                              return item.value == 5
                          })
                            if(index2 > -1) {
                              const index3 = statusList[index2].children.findIndex(item => {
                                return item.value == 18
                              })
                              if (index3 > -1) {
                                statusList[index2].children.splice(index3, 1)
                              }
                            }


                          }
                          // this.conditions.status.forEach(item => {
                          //   this.handleStatusList.push(item)
                          // })
                            this.handleStatusList=statusList


                          if(params.row.handleStatus === 3 || params.row.handleStatus === 7) {
                            let index = this.handleStatusList.findIndex(item => {
                              return item.value == 1
                            })
                            if(index > -1) {
                              this.handleStatusList.splice(index,1)
                            }
                            index = this.handleStatusList.findIndex(item => {
                              return item.value == 2
                            })
                            if(index > -1) {
                              this.handleStatusList.splice(index,1)
                            }
                          }
                          if( params.row.handleStatus === 7) {
                            const index = this.handleStatusList.findIndex(item => {
                              return item.value == 7
                            })
                            if(index > -1) {
                              this.handleStatusList.splice(index,1)
                            }
                          }
                          this.handleObj=params.row
                          this.handleN++
                          // thissRead = false
                          // this.readOrHandleKey++;
                          // this.businessFid = params.row.businessFid
                          // this.detailProjectFid = params.row.projectFid
                          // this.zoFid = params.row.zoFid
                          // this.uid = params.row.customerUid;
                        }else {
                          this.$Message.error('您没有修改该条商机的权限')
                        }
                      })

                    }
                  }
                },'处理'),


               ])
            }
          },


        ],
        total: 0,
        current: 1,
        loading: false,
        metaList:[],
        page:1,
        limit:10,
        searchParams:null,
        enumList:null,
        conditions:null,

      }
    },
    methods:{
      changeTableRowTextExpandState(i){
        console.log(11)
        this.data = this.data.map(( item,index ) => {
          if( i === index ){
            item.expandText = !item.expandText
          }
          return item;
        })
      },
      selectItem(selection){
        this.selectedBusiness = selection
      },
      assignBusiness() {
        if(this.selectedBusiness.length === 0) {
          this.$Message.error('请选择商机');
        } else {
          const projectFid = this.selectedBusiness[0].projectFid
          const temArr = this.selectedBusiness.filter( (item,i) => {
            return item.projectFid !== projectFid
          })
          if(temArr.length > 0) {
            this.$Message.error('请选择同一项目下的商机');
          } else {
            this.assginProjectFid = projectFid
            this.projectName = this.selectedBusiness[0].projectName
            this.assignCityCode=this.selectedBusiness[0].cityCode

            // this.businessCount = this.selectedBusiness.length
            this.assignKey++
          }
        }
      },
      getBusinessEnums(){
        getBusinessEnums().then( res => {
          if(!res.data){
            return
          }
          this.enumList=res.data

          //
          // this.budgetRangeList = res.data.budgetRange;
          // this.commutingModeList = res.data.commutingMode;
          // this.intentionAreaList = res.data.intentionArea;
          // this.houseTypeList = res.data.houseType;
          // let liveNumberList = res.data.liveNumber;
          // for(var i = 1 ; i <= liveNumberList; i++){
          //   this.liveNumberList.push(i)
          // }
          // this.placeList = res.data.place;
          // this.shortRentDesList = res.data.shortRentDes;
          // this.rentTimeList = res.data.rentTime;
        }).catch(error=>{})

        getConditions().then( res => {
          if(!res.data){
            return

          }
          //企业签约去除待签约
          if( res.data.status){
            const index = res.data.status.findIndex(item => {
              return item.value == 7
            })
            if(index > -1) {
              res.data.status.splice(index,1)
            }
          }
          this.conditions=res.data
          // this.sourceList = res.data.source
          // this.channelList = res.data.channel?res.data.channel:[]
          // this.isLookList = res.data.isLook
          // this.loseReasonList = res.data.loseReason
          // this.clientTypeList = res.data.clientType
          // this.allStatusList = deepClone(res.data.status)
          // this.statusList = res.data.status
          // this.callStatus=res.data.callStatus


        }).catch(error=>{})
      },
      changPage(n){
        this.current = n;
        this.page = n;
        this.getList()
      },
      search(data){
        this.searchParams=data
        this.page=1
        this.current=1
        this.getList()
      },
      getList(){
        const params={
          ...this.searchParams,
          page:this.page,
          limit:this.limit,
        }
        this.loading=true
        enterpriselist(params).then(res=>{
          if(!res.data){
            return
          }
          this.total=res.data.total
          res.data.rows = res.data.rows.map(item => {

            if(item.handleRecord && item.handleRecord.length > 50 ){
              item.expandText = true
              item.expandTextButton = true;
            }else{
              item.expandText = false;
              item.expandTextButton = false;
            }
            return item;
          })
          this.data=res.data.rows?res.data.rows:[]
          this.loading=false

        }).catch(error=>{
          this.loading=false

        })

      },
      // allMetaWithExt(){
      //   allMetaWithExt().then(res=>{
      //     if(!res.data){
      //       return
      //     }
      //     this.metaList=res.data
      //
      //   }).catch(error=>{
      //   })
      // },
      format(data) {
        if (!data) {
          return ''
        }
        return formatDateTime(data)
      }
    }
  }
</script>

<style scoped>

</style>
